export default "__VITE_ASSET__33a83c54__"